import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SharedModule } from 'primeng/api';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'ct-extraction-remove-all-rows-dialog',
  imports: [ConfirmDialogModule, SharedModule, DialogComponent],
  templateUrl: './remove-all-rows-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoveAllRowsDialogComponent {
  readonly dialogKey = input.required<string>();
  readonly rowCount = input.required<number>();

  readonly acceptedDialog = output<void>();
}
